import { redirect } from 'react-router-dom';
import { getGeneralSettings } from './helper/apiHelper.js'

const HOME_ROUTE = '/';
const DASHBOARD_ROUTE = '/home';

function getUserFromLocalStorage() {
    const userString = localStorage.getItem('user');
    return userString ? JSON.parse(userString) : null;
}

function isAuthenticated() {
    return localStorage.getItem('access_token') && getUserFromLocalStorage() && localStorage.getItem('access_token') !== 'null';
}

function hasValidWallet(user) {
    return user?.wallet?.social_id && user?.wallet?.user_id;
}

export function requireAuth() {
    if (!isAuthenticated()) {
        return redirect(HOME_ROUTE);
    }

    const user = getUserFromLocalStorage();
    return hasValidWallet(user) ? true : redirect(HOME_ROUTE);
}

export async function signupAuth() {
    // if (!isAuthenticated()) {
    //     return redirect(HOME_ROUTE);
    // }

    const user = getUserFromLocalStorage();
    if (!user?.wallet?.social_id) {
        return redirect(HOME_ROUTE);
    }
    const response = await getGeneralSettings();
    if (response) {
        localStorage.setItem('timeZone', response.time_zone);
    }
    return user.wallet.user_id ? redirect(DASHBOARD_ROUTE) : true;
}
